export const errors = {
  E_ALIAS_NOT_FOUND: 'El alias no existe',
  E_ALIAS_NOT_VERIFIED:
    'Aún no hemos podido verificar tu alias. Por favor, revisa tu bandeja de entrada o tus mensajes para confirmar tu cuenta.',
  E_INVALID_OTP:
    'El código de verificación es incorrecto. Por favor, verifica el código e inténtalo de nuevo.',
  E_TOO_MANY_ATTEMPTS:
    'Has superado el número máximo de intentos. Por favor, inténtalo de nuevo más tarde.',
};
